//import core from "core";
import * as fs from "filesystem";

const PATH = "/tmp/upgradables.txt";
const CMD = "apt list --upgradable > " + PATH;

global.onmessage = function(event) {
  var subProcess = new SubProcess();
  subProcess.call(CMD);    

  var arrayBuffer = fs.readFileSync(PATH);
  var str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
   
  global.postMessage(str.includes("jfermi") || str.includes("jfermi-beta"));

  close();
}